import paths from 'paths';
import url from 'url';

export function getReturnPath(options = {}, location = null) {
    // todo: utilize react-router 'location' prop instead of 'match', see Member.js
    options = Object.assign({}, {match: null, hashBang: true}, options);

    let {match, hashBang} = options;

    if (match) {
        return (hashBang ? '/#' : '') + match.url;
    }

    // ssr location
    if (location) {
        if (hashBang) {
            return location.pathname + location.hash;
        }
        return location.pathname;
    }

    if (hashBang) {
        return window.location.pathname + window.location.hash;
    }

    return window.location.pathname;
}

// todo: replace usages of getPaymentUrl() with paths.buyXXL.toPath()

export function getPaymentUrl(returnPath = null, xxlReceiver = null) {
    return paths.paymentOrder.path + '?'
    // return paths.buyXXL.path + '?'
        + (returnPath ? ('return_path='+encodeURIComponent(returnPath)) : '')
        + (xxlReceiver ? ('&r='+encodeURIComponent(xxlReceiver)) : '');
}

export function getLoginPath(returnPath) {
    return {
        pathname: '/',
        search: '?login&return_path=' + encodeURIComponent(returnPath)
    }
}

export function addCacheBuster(url) {
    let delimiter = url.indexOf("?") !== -1 ? "&" : "?";
    return url + delimiter + "_=" + (new Date().getTime());
}

export function addParam(aUrl, name, value) {
    let oUrl = url.parse(aUrl, true);
    //let search_params = new URLSearchParams(oUrl.search);
    //search_params.append(name, value);
    //oUrl.search = search_params.toString();

    oUrl.query[name] = value;
    //console.log("oUrl:", oUrl);

    oUrl.search = null;

    return url.format(oUrl);
}

export function addHashParam(aUrl, name, value) {
    let oUrl = url.parse(aUrl, true);

    let search_params = new URLSearchParams(oUrl.hash ? oUrl.hash.slice(1) : "");
    search_params.append(name, value);
    oUrl.hash = search_params.toString();

    return url.format(oUrl);
}

export function isSameRoomURL(url1, url2) {
    let oUrl1 = url.parse(url1, true);
    let oUrl2 = url.parse(url2, true);

    return oUrl1.pathname === oUrl2.pathname && oUrl1.query["s"] === oUrl2.query["s"] && oUrl1.query["roomid"] === oUrl2.query["roomid"];
}


// WEBPACK FOOTER //
// ./src/utils/url.js